import React, { useState } from 'react';

const STATS = [
  { value: '2,000+', label: 'practices trust us' },
  { value: '500,000', label: 'patients covered' },
];

const TRUSTED = ['Dandy', 'NOBS', 'Mouthology', 'Flaus'];

const stripeBg = 'repeating-linear-gradient(135deg,rgba(17,17,17,.09) 0 5px,transparent 5px 11px)';

function WallOfLoveStat() {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href="https://freedentalsamples.com/wall-of-love"
      className="mx-stats-last"
      style={{ padding: '26px 40px', textDecoration: 'none', display: 'block', background: hovered ? '#dcedc2' : 'transparent', transition: 'background .2s ease', borderLeft: '1px solid rgba(17,17,17,.18)' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ font: '600 34px Archivo,sans-serif', letterSpacing: '-.02em', color: '#111' }}>Wall of love</div>
      <div style={{ font: '400 12px "IBM Plex Mono",monospace', color: '#2a2a2a', marginTop: '4px' }}>what they say about us →</div>
    </a>
  );
}

export default function Hero() {
  return (
    <div style={{ background: '#f3f9e9' }}>
      {/* Hero */}
      <div className="mx-hero-grid">
        <div>
          <div style={{ font: '500 11px "IBM Plex Mono",monospace', letterSpacing: '.14em', color: '#2a2a2a', marginBottom: '26px' }}>
            MOMOROX &nbsp;/&nbsp; INFRASTRUCTURE FOR DENTISTRY
          </div>
          <h1 className="mx-hero-head" style={{ margin: 0, textWrap: 'balance' }}>
            Dentistry runs on introductions. We built the rails.
          </h1>
        </div>
        <div style={{ paddingBottom: '10px' }}>
          <p style={{ margin: '0 0 28px', font: '400 17px/1.6 Archivo,sans-serif', color: '#2a2a2a', textWrap: 'pretty' }}>
            Software that talks to the software you run. Assistant that books patients while the office is closed. Free samples from the brands you already prescribe. Labs that will take your case, with turnaround published up front.
          </p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <PracticeBtn />
            <BrandBtn />
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="mx-stats-grid">
        {STATS.map(({ value, label }) => (
          <div key={label} style={{ padding: '26px 20px', borderRight: '1px solid rgba(17,17,17,.18)' }}>
            <div style={{ font: '600 34px Archivo,sans-serif', letterSpacing: '-.02em', color: '#111' }}>{value}</div>
            <div style={{ font: '400 12px "IBM Plex Mono",monospace', color: '#2a2a2a', marginTop: '4px' }}>{label}</div>
          </div>
        ))}
        <WallOfLoveStat />
      </div>

      {/* Trusted by */}
      <div className="mx-trusted">
        <span style={{ font: '500 11px "IBM Plex Mono",monospace', letterSpacing: '.14em', color: '#2a2a2a', whiteSpace: 'nowrap' }}>TRUSTED BY</span>
        <div className="mx-trusted-logos">
          {TRUSTED.map(name => (
            <div key={name} style={{ height: '26px', flex: 1, minWidth: '60px', backgroundImage: stripeBg, display: 'flex', alignItems: 'center', justifyContent: 'center', font: '400 13px "IBM Plex Mono",monospace', color: '#111' }}>
              {name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function PracticeBtn() {
  const [hovered, setHovered] = useState(false);
  return (
    <a href="https://concierge.momorox.com" style={{ font: '500 14px Archivo,sans-serif', color: '#f3f9e9', background: hovered ? '#000' : '#111', textDecoration: 'none', padding: '13px 22px', borderRadius: '2px', transition: 'background .18s ease' }} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      I run a practice
    </a>
  );
}

function BrandBtn() {
  const [hovered, setHovered] = useState(false);
  return (
    <a href="mailto:nick@momorox.com" style={{ font: '500 14px Archivo,sans-serif', color: '#111', background: hovered ? '#dcedc2' : 'transparent', textDecoration: 'none', padding: '12px 21px', border: '1px solid #111', borderRadius: '2px', transition: 'background .18s ease' }} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      I'm a brand or lab
    </a>
  );
}
